module.exports = __webpack_public_path__ + "img/bg_year@2x.474ed069.png";